<template>
    <header>
        <nav class="bg-white text-center d-flex justify-content-center">

            <a class="acessar-net-shopping btn btn-shopping rounded-pill " @click="acessarShopping()"><img src="../assets/images/logo_shoppingcna.png" class="mr-1" height="25" style="" /> Shopping CNA </a>

            <a class="navbar-brand p-0 my-0 mx-auto mx-md-0 logo-topo" href="javascript:;">
                <img src="../assets/images/logo_cna_circulo.png" alt="CNA" Title="CNA" width="180" class="mb-4">
            </a>

            <a class="acessar-net-shopping btn btn-cnanet rounded-pill " @click="acessarCNANet()">CNA Net <img src="../assets/images/cna-logo-white.svg" class="ml-1" height="20" /></a>

        </nav>
    </header>


</template>

<style>

    header {
        display: flex;
        justify-content: center;
    }

    nav.text-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

<script>

    import Auth from '@/common/auth'
    import Global from '@/common/global'

    export default {
        name: "header-cna",
        data() {
            return {
                user: {},
            }
        },

        watch: {
            '$route'(to) {

            }
        },
        computed: {
        },
        methods: {
            acessarShopping() {
                window.location = Global.URL_SHOPPING_CNA;
            },
            acessarCNANet() {
                window.location = Global.URL_CNA_NET;
            },
            logout() {
                Auth.logout()
            },
        },
        mounted() {
            this.user = Auth.currentUser();
        },

    };
</script>